import { render, staticRenderFns } from "./ConfigWave.vue?vue&type=template&id=04e522a4&scoped=true&"
import script from "./ConfigWave.vue?vue&type=script&lang=ts&"
export * from "./ConfigWave.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigWave.vue?vue&type=style&index=0&id=04e522a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e522a4",
  null
  
)

export default component.exports